import axios from "axios";
import config from "../config";

export function setupCallRecordingApi(data) {
  return axios.post(`${config.api_url}/call-recording-api-setup`, data);
}

export function setupIpecsManager(data) {
  return axios.post(`${config.api_url}/ipecs-manager-setup`, data);
}

export function previewMeetingNotesInstructions(data) {
  return axios.post(
    `${config.api_url}/meeting-notes-instructions/preview`,
    data,
  );
}
